import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/trafo.png'


const _hoisted_1 = { class: "node" }
const _hoisted_2 = { class: "block" }
const _hoisted_3 = { class: "circuit" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_toggle = _resolveComponent("ion-toggle")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(_toDisplayString(_ctx.dataSet.transformerCircuit), 1)
        ]),
        _hoisted_5,
        _createElementVNode("div", {
          class: _normalizeClass(["name", _ctx.dataSet.enabled ? 'enabled' : 'disabled'])
        }, _toDisplayString(_ctx.dataSet.componentName), 3),
        _createElementVNode("div", null, [
          (_ctx.dataSet.projectId > 0)
            ? (_openBlock(), _createBlock(_component_ion_toggle, {
                key: 0,
                checked: _ctx.dataSet.enabled,
                onClick: _ctx.handle
              }, null, 8, ["checked", "onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (Array.isArray(_ctx.dataSet.children) && _ctx.dataSet.children.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "extend_handle",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('extend', _ctx.dataSet)))
        }))
      : _createCommentVNode("", true)
  ]))
}